import type { SVGProps } from "react";
import { forwardRef } from "react";
import type { Ref } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgRingtone = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    focusable="false"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6.067 11.134a5.933 5.933 0 1 1 11.866 0l.001 1.192c0 .705.155 1.4.456 2.038l.421.895a2.063 2.063 0 0 1-1.866 2.94h-9.89a2.062 2.062 0 0 1-1.866-2.94l.421-.895c.3-.638.456-1.333.456-2.038z"
      clipRule="evenodd"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.2 18.2a2.8 2.8 0 0 0 5.6 0M13.604 5.414v-.81a1.605 1.605 0 0 0-3.21 0v.81"
      opacity={0.4}
    />
  </svg>
);
const ForwardRef = forwardRef(SvgRingtone);
export default ForwardRef;
